import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Button,
  Space,
  Cascader,
  Alert,
} from 'antd';
import moment from 'moment';
import * as Config from '../../../appConfig';
import { activePeriod, disabledDate, isSunday } from '../../../utils/date';

import getFormattedLocations from '../../../utils/getFormattedLocations';

const GeneratePayslipForm = ({
  onGeneratePayslipSubmit,
  onCancelClick,
  locations,
  errors,
  onCloseError,
  ability,
}) => {
  const [form] = Form.useForm();

  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  const locationsWithAll = [
    { id: -1, name: 'All', region: { id: -1, name: 'All' } },
    ...locations,
  ];

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{
          for_month: moment(),
          location: [-1, -1],
        }}
        onFinish={(values) =>
          onGeneratePayslipSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        {errors && (
          <Alert
            message="Payslip Error"
            description={errors}
            type="error"
            closable
            onClose={onCloseError}
          />
        )}
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Month"
              name="for_month"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) =>
                  disabledDate(
                    current,
                    false,
                    currentMonth,
                    prevMonth
                  ) || isSunday(current)
                }
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Location"
              name="location"
              rules={[{ required: true, message: 'Please select Location!' }]}
            >
              <Cascader
                options={getFormattedLocations(locationsWithAll)}
                defaultValue={['All']}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24}>
            <p>&nbsp;</p>
            {/* <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item> */}
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Generate Payslip
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default GeneratePayslipForm;
